export class LookupColumnRequest {
  public lookupId: string;
  public columnIds: string[] = [];

  constructor(lookupId: string, columnIds: string[]) {
    this.lookupId = lookupId;
    this.columnIds = columnIds;
  }
}
